import axios from "axios";
import { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ListPrestasi from "./ListPrestasi";

const AddPrestasi = () => {
  const [form, setForm] = useState({
    judul: "",
    deskripsi: "",
    tanggal: "",
  });
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    setFile(selected);
    setPreview(URL.createObjectURL(selected));
  };

  const handleSubmit = async () => {
    if (!form.judul || !form.deskripsi || !form.tanggal) {
      toast.error("Judul, deskripsi, dan tanggal wajib diisi.");
      return;
    }

    const formData = new FormData();
    formData.append("judul", form.judul);
    formData.append("deskripsi", form.deskripsi);
    formData.append("tanggal", form.tanggal);
    if (file) formData.append("gambar", file); // sesuai backend terbaru

    try {
      setIsUploading(true);
      await axios.post(
        `${process.env.REACT_APP_API_URL}api/prestasi`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      toast.success("Prestasi berhasil ditambahkan!");
      setForm({ judul: "", deskripsi: "", tanggal: "" });
      setFile(null);
      setPreview(null);
    } catch (err) {
      toast.error(err.response?.data?.error || "Gagal menambahkan prestasi.");
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="bg-white rounded shadow p-6 max-w-xl mx-auto">
      <ToastContainer />
      <h2 className="text-xl font-bold mb-4 text-center">Tambah Prestasi</h2>

      <input
        type="text"
        name="judul"
        placeholder="Judul"
        value={form.judul}
        onChange={handleChange}
        className="w-full p-2 border rounded mb-3"
      />
      <textarea
        name="deskripsi"
        placeholder="Deskripsi"
        value={form.deskripsi}
        onChange={handleChange}
        className="w-full p-2 border rounded mb-3"
      />
      <input
        type="date"
        name="tanggal"
        value={form.tanggal}
        onChange={handleChange}
        className="w-full p-2 border rounded mb-3"
      />
      <input
        type="file"
        accept="image/jpeg, image/png"
        onChange={handleFileChange}
        className="block mb-3 text-sm"
      />
      {preview && (
        <img
          src={preview}
          alt="Preview"
          className="w-full max-h-64 object-contain mb-3 border rounded"
        />
      )}
      <button
        onClick={handleSubmit}
        disabled={isUploading}
        className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
      >
        {isUploading ? "Mengunggah..." : "Simpan Prestasi"}
      </button>

      <div className="mt-6">
        <ListPrestasi />
      </div>
    </div>
  );
};

export default AddPrestasi;
